import { Refresh } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';


export function RefreshButton({refetch, isFetching}:{refetch: () => void, isFetching: boolean}) {
  return (
    <LoadingButton variant="outlined" onClick={() => refetch()} loading={isFetching} aria-label="Refresh" loadingPosition="center" title="Refresh"
      sx={{ 
        minWidth: 0, 
        width: 40, 
        height: 40, 
        borderRadius: '50%', 
      }}
    >
      <Refresh/>
    </LoadingButton>
  )
}
